import { FC } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FieldPath, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@/hooks/graphql/useMutation';
import { useNotify } from '../../../../hooks/useNotify';
import { eachValidationErrorsForHookFrom, ServerValidationError } from '@/hooks/graphql/error/ServerValidationError';
import styles from './CreateHealthCheckupInstitution.scss';
import { HealthCheckupInstitutionForm } from '../edit/parts/HealthCheckupInstitutionForm';
import { parseBackUrl } from '@/utils/url';
import { CREATE_HEALTH_CHECKUP_INSTITUTION, CreateHealthCheckupInstitutionQueryVariables } from './mutation';
import { Schema, schema, defaultValues } from '../edit/schema';

export const CreateHealthCheckupInstitution: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const notify = useNotify();

  const methods = useForm<Schema>({
    defaultValues,
    resolver: yupResolver(schema)
  });
  const { handleSubmit, setError } = methods;

  const [createHealthCheckupInstitution] = useMutation<unknown, CreateHealthCheckupInstitutionQueryVariables>(
    CREATE_HEALTH_CHECKUP_INSTITUTION
  );

  const onSubmit: SubmitHandler<Schema> = async data => {
    try {
      await createHealthCheckupInstitution({
        variables: {
          input: {
            healthCheckupInstitutionId: data.healthCheckupInstitutionId,
            name: data.name,
            location: data.location
          }
        }
      });

      notify('作成しました', 'success');
      history.push('/settings/health_checkup_institution');
    } catch (err) {
      if (err instanceof ServerValidationError) {
        eachValidationErrorsForHookFrom(err.validationErrors, schema, data, (path, error) => {
          setError(path as FieldPath<Schema>, error);
        });
        return;
      }
      throw err;
    }
  };

  return (
    <FormProvider {...methods}>
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">健康診断実施機関新規登録</h1>
        </div>
        <div className="l-contents-wrap">
          <div className="l-wrap-xl">
            <div className={styles.main}>
              <HealthCheckupInstitutionForm
                onSubmit={handleSubmit(onSubmit)}
                onCancel={() => history.push(parseBackUrl(location, '/settings/health_checkup_institution'))}
              />
            </div>
          </div>
        </div>
      </div>
    </FormProvider>
  );
};
